import { Button, DatePicker, Descriptions, Popover, Typography } from "antd"
import { useContext, useState } from "react"
import JobSelector from "../jobs/JobSelector"
import { useJobQuery, useVisitQuery } from "./apiQueries"
import EditVisitContext from "./EditVisitContext"
import { getJobId, isVisitDateChanged } from "./editVisitModel"
import dayjs, { Dayjs } from 'dayjs'

const { Text } = Typography

type Props = {
  timeZone: string
}

const JobAndDateSection = ({ timeZone }: Props) => {
  const data = useContext(EditVisitContext)
  const visitQuery = useVisitQuery(data.visitId)
  const jobId = getJobId(data, visitQuery.data)

  const jobQuery = useJobQuery(jobId, data.visitId)
  const hasJob = jobId !== undefined
  const [isPopupOpen, setIsPopupOpen] = useState(!hasJob)

  const buildJobText = () => {
    if (!hasJob) {
      return <Text type="secondary" italic>No job selected</Text>
    }
    if (jobQuery.isLoading) {
      return <Text type="secondary" italic>Loading job data...</Text>
    }
    return <>
      <Text>{jobQuery.data?.name}</Text><br />
      <Text type="secondary">{jobQuery.data?.customerName}</Text>
    </>
  }

  const visitDate = data.visitDate ?? visitQuery.data?.visitDate

  const onVisitDateChange = (newDate: Dayjs | null) => {
    data.dispatch({ type: 'VISIT_DATE_CHANGED', payload: newDate!.toISOString() })
  }

  return <Descriptions bordered>
    <Descriptions.Item label='Job'>
      {buildJobText()}
    </Descriptions.Item>
    {data.isNewVisit &&
      <Descriptions.Item>
        <Popover
          trigger="click"
          title="Select a Job"
          placement="bottom"
          open={isPopupOpen}
          onOpenChange={(open: boolean) => setIsPopupOpen(open)}
          content={<JobSelector onJobSelected={(jobId: number) => {
            data.dispatch({ type: 'JOB_ID_CHANGED', payload: jobId })
            setIsPopupOpen(false)
          }} />}
        >
          <Button>{hasJob ? 'Select a Different Job' : 'Select Job'}</Button>
        </Popover>
      </Descriptions.Item>
    }
    <Descriptions.Item label="Visit Date">
      <DatePicker
        value={dayjs(visitDate).tz(timeZone)}
        onChange={onVisitDateChange}
        allowClear={false}
        status={isVisitDateChanged(visitQuery.data?.visitDate, data) ? 'warning' : undefined} />
    </Descriptions.Item>
  </Descriptions>
}
export default JobAndDateSection
